+function ($) {
    $(document).ready(function(){
        $('.contact-form--with-client #client-type input[type=radio]').change(function() {
            if ($(this).val() === 'individual') {
                $('#company-name').hide();
            }
            if ($(this).val() === 'corporate') {
                $('#company-name').show();
            }
        });
    });
}(jQuery);
